export default __webpack_public_path__ + "static/media/chef-hat.6717b7ae.svg";